import {
  Facebook,
  GitHub,
  Instagram,
  LinkedIn,
  Pinterest,
  Reddit,
  Twitter,
  Videocam,
  WhatsApp,
  YouTube,
} from '@mui/icons-material'
import { partition } from 'lodash'

import Snapchat from '~/assets/images/misc/snapchat.svg?react'
import Tiktok from '~/assets/images/misc/tiktok.svg?react'
import { ESocialLinks } from '~/features/chatbot/models'
import { TLink } from '~/features/settings/models'

const socialLinksIcons = {
  [ESocialLinks.facebook]: <Facebook />,
  [ESocialLinks.instagram]: <Instagram />,
  [ESocialLinks.linkedin]: <LinkedIn />,
  [ESocialLinks.twitter]: <Twitter />,
  [ESocialLinks.yoututbe]: <YouTube />,
  [ESocialLinks.github]: <GitHub />,
  [ESocialLinks.pinterest]: <Pinterest />,
  [ESocialLinks.reddit]: <Reddit />,
  [ESocialLinks.snapchart]: <Snapchat />,
  [ESocialLinks.tiktok]: <Tiktok />,
  [ESocialLinks.whatsapp]: <WhatsApp />,
  [ESocialLinks.zoom]: <Videocam />,
}

export const partializeLinks = (allLinks: TLink[]) => {
  const allSocialLinks = Object.values(ESocialLinks)
  return partition(allLinks, (link) =>
    allSocialLinks.some((socialLink) => link.url.includes(socialLink)),
  )
}

export const getSocialLinkIcon = (socialLink: string) => {
  const allSocialLinks = Object.values(ESocialLinks)
  const socialLinkIndex = allSocialLinks.findIndex((link) =>
    socialLink.includes(link),
  )
  return socialLinksIcons[allSocialLinks[socialLinkIndex] as ESocialLinks]
}
